import {
    FormControl,
    FormLabel,
    Input,
    Select,
    FormErrorMessage,
    FormHelperText
} from '@chakra-ui/react'

interface FormFieldProps {
    label: string
    name: string
    type: string
    error?: { message?: string }
    required?: boolean
    accept?: string
    register: any
    helperText?: string
    children?: React.ReactNode
}

export default function FormField({
    label,
    name,
    type,
    error,
    accept,
    required,
    register,
    helperText,
    children
}: FormFieldProps) {
    return (
        <FormControl isInvalid={Boolean(error)} isRequired={required}>
            <FormLabel>{label}</FormLabel>
            {type === 'select' ? (
                <Select id={name} placeholder={`Select ${label}`} {...register(name)}>
                    {children}
                </Select>
            ) : (
                <Input type={type} id={name} {...register(name)} accept={accept} />
            )}
            <FormErrorMessage>{error && error.message}</FormErrorMessage>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    )
}
